export const DISCOVERY_URL = "https://dammi.lv/discovery";

